

import React from 'react';

const NavigationDots = ({ active }) => (
  <div className="app__navigation">
    {['home', 'about', 'Project_Gallary', 'CV', 'testimonial'].map((item, index) => (
      <a
        href={`#${item}`}
        key={item + index}
        className="app__navigation-dot"
        style={active === item ? { backgroundColor: 'orange' } : {position: 'relative', zIndex: '1'}}
        
        
        
      />
    ))}
  </div>
);

export default NavigationDots;